import { MouseEventHandler, useState } from "react";
import { Trans } from "@coworker/locales";
import { FixaListView } from "../../../shared/wrappers/FixaListView/FixaListView";
import { FixaListViewItem } from "../../../shared/wrappers/FixaListView/FixaListViewItem";
import { ClearSearchHistory } from "./ClearSearchHistory";
import { ProductSearchHistoryItem } from "./ProductSearchHistoryItem";

interface ProductSearchHistoryPresentationProps {
  searchHistory: string[];
  onDeleteHistoryItem: (historyItem: string) => void;
  onClearHistory: () => void;
  onHistoryItemClick: (historyItem: string) => void;
  onHistoryItemMouseDown?: MouseEventHandler<HTMLDivElement> | undefined;
}

export const ProductSearchHistoryPresentation = ({
  searchHistory,
  onDeleteHistoryItem,
  onClearHistory,
  onHistoryItemClick,
  onHistoryItemMouseDown,
}: ProductSearchHistoryPresentationProps) => {
  const [openSwipeIndex, setOpenSwipeIndex] = useState<number | null>(null);

  return (
    <FixaListView id="product-search-history" size={"small"}>
      <FixaListViewItem
        id={"search-history-title"}
        title={<Trans>searchHistoryString</Trans>}
        size="small"
        inset
        emphasised
        quantityLabel={<ClearSearchHistory onClick={onClearHistory} />}
      />
      {searchHistory.map((historyItem, i) => (
        <ProductSearchHistoryItem
          key={i}
          historyItem={historyItem}
          showDelete={openSwipeIndex === i}
          onShowDelete={() => setOpenSwipeIndex(i)}
          onHideDelete={() => setOpenSwipeIndex(null)}
          onDelete={() => onDeleteHistoryItem(historyItem)}
          onClick={() => onHistoryItemClick(historyItem)}
          onMouseDown={onHistoryItemMouseDown}
        />
      ))}
    </FixaListView>
  );
};
